// TSS vite/03 §"Query keys convention". Entity first: these are documents.
export const documentationKeys = {
    all:      ['documents'],
    list:     (params) => ['documents', 'list', params],
    latest:   (id) => ['documents', 'detail', String(id), 'latest-version'],
};
